import { Badge } from '@/components/ui/badge';
import { getStatusColor, getStatusLabel } from '@/lib/expense-utils';

interface ExpenseStatusBadgeProps {
  status: 'pending' | 'overdue' | 'paid';
}

export function ExpenseStatusBadge({ status }: ExpenseStatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      className="gap-1.5 border-0"
      style={{ color: getStatusColor(status), backgroundColor: `${getStatusColor(status)}15` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: getStatusColor(status) }} />
      {getStatusLabel(status)}
    </Badge>
  );
}
